import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const basketItemsStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
  },
  listSeparator: {
    height: 1,
    backgroundColor: "rgb(244, 237, 231)",
  },
  emptyBasketText: {
    flex: 1,
    fontFamily: "HelveticaNeue",
    color: colors.disabledText,
    textAlign: "center",
    fontSize: fontSizes.x14,
    letterSpacing: 0,
    marginTop: 20,
  },
  listfooter: {
    paddingBottom: 80,
  },
  listItemContainer: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: 80,
  },
});

export const getLineItemStyles = (selectedBasketItem: boolean) =>
  StyleSheet.create({
    lineItemContainer: {
      flexDirection: "row",
    },
    lineContainer: {
      paddingTop: 10,
      paddingHorizontal: 10,
      width: "100%",
    },
    lineItemDisabledText: {
      color: selectedBasketItem ? colors.white : colors.disabledText,
    },
    lineItemTitleText: {
      fontFamily: "HelveticaNeue",
      textAlign: "left",
      color: selectedBasketItem ? colors.white : colors.text,
      fontSize: fontSizes.x14,
      letterSpacing: 0,
    },
    lineItemTitleContainer: {
      flex: 11,
      justifyContent: "center",
    },
    lineQuantityContainer: {
      flex: 3,
      alignItems: "flex-start",
      justifyContent: "center",
    },
    lineCircle: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 100,
      backgroundColor: colors.cedar10,
    },
    lineQuantityText: {
      color: selectedBasketItem ? colors.white : colors.text,
      fontFamily: "HelveticaNeue",
      fontSize: fontSizes.x14,
      textAlign: "right",
      letterSpacing: 0,
    },
    lineItemTotalContainer: {
      flex: 4,
      alignItems: "flex-end",
      justifyContent: "center",
    },
    lineItemTotalText: {
      color: selectedBasketItem ? colors.white : colors.primary,
      fontFamily: "HelveticaNeue",
      fontSize: fontSizes.x12,
      textAlign: "right",
      letterSpacing: 0,
    },
  });
